"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ReactDOM = require("react-dom");
const react_redux_1 = require("react-redux");
const actions_1 = require("../../../actions");
const reducers_1 = require("../../../reducers");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const MobilePopover_1 = require("../components/MobilePopover");
const Row_1 = require("../components/Row");
const react_responsive_1 = require("react-responsive");
const PreviewPortal_1 = require("../components/PreviewPortal");
const MessageAndMediaIcon_1 = require("./MessageAndMedia/MessageAndMediaIcon");
const grid = 'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAxMSAxMSIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj7CoMKgwqDCoDxnIGZpbGw9IiMwMDAwMDAiPsKgwqDCoMKgwqDCoMKgwqA8cmVjdCB4PSIxIiB5PSIwIiB3aWR0aD0iMSIgaGVpZ2h0PSIxIiBvcGFjaXR5PSIwLjA0Ii8+wqDCoMKgwqDCoMKgwqDCoDxyZWN0IHg9IjEiIHk9IjEiIHdpZHRoPSIxIiBoZWlnaHQ9IjEiIG9wYWNpdHk9IjAuMTAiLz7CoMKgwqDCoMKgwqDCoMKgPHJlY3QgeD0iMSIgeT0iMiIgd2lkdGg9IjEiIGhlaWdodD0iMSIgb3BhY2l0eT0iMC4wNCIvPsKgwqDCoMKgwqDCoMKgwqA8cmVjdCB4PSIxIiB5PSI1IiB3aWR0aD0iMSIgaGVpZ2h0PSIxIiBvcGFjaXR5PSIwLjAyIi8+wqDCoMKgwqDCoMKgwqDCoDxyZWN0IHg9IjEiIHk9IjciIHdpZHRoPSIxIiBoZWlnaHQ9IjEiIG9wYWNpdHk9IjAuMDIiLz7CoMKgwqDCoMKgwqDCoMKgPHJlY3QgeD0iMSIgeT0iOSIgd2lkdGg9IjEiIGhlaWdodD0iMSIgb3BhY2l0eT0iMC4wMiIvPsKgwqDCoMKgwqDCoMKgwqA8cmVjdCB4PSIwIiB5PSIxIiB3aWR0aD0iMSIgaGVpZ2h0PSIxIiBvcGFjaXR5PSIwLjA0Ii8+wqDCoMKgwqDCoMKgwqDCoDxyZWN0IHg9IjIiIHk9IjEiIHdpZHRoPSIxIiBoZWlnaHQ9IjEiIG9wYWNpdHk9IjAuMDQiLz7CoMKgwqDCoMKgwqDCoMKgPHJlY3QgeD0iNSIgeT0iMSIgd2lkdGg9IjEiIGhlaWdodD0iMSIgb3BhY2l0eT0iMC4wMiIvPsKgwqDCoMKgwqDCoMKgwqA8cmVjdCB4PSI3IiB5PSIxIiB3aWR0aD0iMSIgaGVpZ2h0PSIxIiBvcGFjaXR5PSIwLjAyIi8+wqDCoMKgwqDCoMKgwqDCoDxyZWN0IHg9IjkiIHk9IjEiIHdpZHRoPSIxIiBoZWlnaHQ9IjEiIG9wYWNpdHk9IjAuMDIiLz7CoMKgwqDCoDwvZz48L3N2Zz4=")';
class ExperienceSelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isSearchFocused: false,
            experienceSearch: '',
            screenSearch: '',
        };
        this.closePopover = this.closePopover.bind(this);
        this.setState = this.setState.bind(this);
    }
    closePopover() {
        const { closePopoverModalForm, device, updateActivePopover } = this.props;
        closePopoverModalForm();
        setTimeout(() => {
            this.setState({ experienceSearch: '' });
            updateActivePopover('');
        }, device === 'Mobile' ? 500 : 0);
    }
    getFilteredExperiences() {
        const { experiences } = this.props;
        const { experienceSearch } = this.state;
        return experiences.filter(({ name }) => name.toLowerCase().includes(experienceSearch.toLowerCase()) || experienceSearch === '');
    }
    getFilteredExperienceScreens() {
        const { editableCampaign, experiences } = this.props;
        const { deliverable } = editableCampaign;
        const { tapBehavior } = deliverable;
        const experienceId = tapBehavior.type === 'PRESENT_EXPERIENCE' ? tapBehavior.experienceID : '';
        const experience = experiences.find(({ id }) => id === experienceId);
        if (!experience) {
            return [];
        }
        const { screenSearch } = this.state;
        if (screenSearch === '') {
            return experience.screens;
        }
        return experience.screens.filter(({ name }) => name.toLowerCase().includes(screenSearch.toLowerCase()));
    }
    renderExperiencePreview() {
        const { device, editableCampaign, experiences } = this.props;
        const { deliverable } = editableCampaign;
        const { tapBehavior } = deliverable;
        const experienceId = tapBehavior.type === 'PRESENT_EXPERIENCE' ? tapBehavior.experienceID : '';
        const screenId = tapBehavior.type === 'PRESENT_EXPERIENCE' ? tapBehavior.screenID : '';
        const experience = experiences.find(({ id }) => id === experienceId);
        const style = {
            position: 'absolute',
            top: device !== 'Desktop' ? 0 : 96,
            zIndex: 11,
            left: device !== 'Desktop' ? 0 : 24,
            height: 568,
            width: 320,
        };
        const simulatorURL = experience ? `${experience.simulatorURL}?showStatusBar=true` : undefined;
        const preview = (React.createElement(React.Fragment, null,
            React.createElement("div", { style: Object.assign(Object.assign({}, style), { backgroundColor: 'white' }) },
                React.createElement(MessageAndMediaIcon_1.default, null)),
            React.createElement("div", { style: Object.assign(Object.assign({}, style), { backgroundImage: grid, display: 'flex', justifyContent: 'space-around', alignItems: 'center' }) },
                React.createElement(src_1.Text, { size: "medium", text: "Select an experience to preview its contents", textStyle: {
                        color: src_1.graphite,
                        textAlign: 'center',
                        width: 162,
                    } })),
            React.createElement("iframe", { id: "experience-preview", src: simulatorURL, style: style, ref: (e) => {
                    if (!e || !e.contentWindow) {
                        return;
                    }
                    e.contentWindow.postMessage({ setScreen: screenId }, '*');
                } })));
        if (device === 'Desktop') {
            return (React.createElement(react_responsive_1.default, { minWidth: 1140 }, ReactDOM.createPortal(preview, document.getElementById('phone-bezel'))));
        }
        return (React.createElement("div", { style: {
                borderRadius: 8,
                overflow: 'hidden',
                position: 'relative',
            } },
            React.createElement(PreviewPortal_1.default, { device: device, title: "Experience Preview" }, preview)));
    }
    renderExperiences() {
        const { device, editableCampaign, updateExperienceTapBehavior } = this.props;
        const { deliverable } = editableCampaign;
        const { tapBehavior } = deliverable;
        const experienceId = tapBehavior.type === 'PRESENT_EXPERIENCE' ? tapBehavior.experienceID : '';
        return (React.createElement(src_1.SelectableList, { device: device }, this.getFilteredExperiences().map(({ id, name, homeScreenId }) => (React.createElement("div", { key: name, onClick: (e) => {
                e.stopPropagation();
                updateExperienceTapBehavior(id, homeScreenId);
                this.closePopover();
            }, style: {
                display: 'flex',
                height: device !== 'Mobile' ? 55 : 71,
                width: '100%',
                justifyContent: 'space-between',
                alignItems: 'center',
            } },
            React.createElement(src_1.Text, { text: name, size: "large" }),
            React.createElement(src_1.RadioButton, { selected: experienceId === id, style: {
                    outerStyle: { height: 18, width: 18 },
                } }))))));
    }
    renderExperienceScreens() {
        const { device, editableCampaign, updateExperienceTapBehavior } = this.props;
        const { deliverable } = editableCampaign;
        const { tapBehavior } = deliverable;
        const experienceId = tapBehavior.experienceID;
        const screenId = tapBehavior.screenID;
        return (React.createElement(src_1.SelectableList, { device: device }, this.getFilteredExperienceScreens().map(({ name, id }) => (React.createElement("div", { key: name, onClick: (e) => {
                e.stopPropagation();
                updateExperienceTapBehavior(experienceId, id);
                this.closePopover();
            }, style: {
                display: 'flex',
                height: device !== 'Mobile' ? 55 : 71,
                width: '100%',
                justifyContent: 'space-between',
                alignItems: 'center',
            } },
            React.createElement(src_1.Text, { text: name, size: "large" }),
            React.createElement(src_1.RadioButton, { selected: screenId === id, style: {
                    outerStyle: { height: 18, width: 18 },
                } }))))));
    }
    renderExperienceChooser() {
        const { device, editableCampaign, experiences, updateActivePopover } = this.props;
        const { deliverable } = editableCampaign;
        const { tapBehavior } = deliverable;
        const experienceId = tapBehavior.type === 'PRESENT_EXPERIENCE' ? tapBehavior.experienceID : '';
        const experience = experiences.filter(({ id }) => id === experienceId)[0];
        return (React.createElement(Row_1.default, { onClick: () => updateActivePopover('experience-selector-popover') },
            React.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
                React.createElement(src_1.Text, { size: "small", text: "Which Experience?", label: true }),
                React.createElement(src_1.Text, { size: "large", text: experience ? experience.name : '' })),
            React.createElement("div", { style: {
                    height: '100%',
                    width: 64,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                } },
                device === 'Mobile' && React.createElement(src_1.ChangeIcon, { fill: src_1.titanium, style: { marginLeft: 16 } }),
                device === 'Mobile' ? this.renderMobilePopover() : this.renderPopover())));
    }
    renderScreenChooser() {
        const { device, editableCampaign, experiences, updateActivePopover } = this.props;
        const { deliverable } = editableCampaign;
        const { tapBehavior } = deliverable;
        const experienceId = tapBehavior.type === 'PRESENT_EXPERIENCE' ? tapBehavior.experienceID : '';
        const screenId = tapBehavior.type === 'PRESENT_EXPERIENCE' ? tapBehavior.screenID : '';
        const experience = experiences.filter(({ id }) => id === experienceId)[0];
        if (experience === undefined) {
            return null;
        }
        const screen = (experience.screens || []).find((s) => s.id === screenId);
        return (React.createElement(Row_1.default, { onClick: () => updateActivePopover('experience-screen-selector-popover') },
            React.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
                React.createElement(src_1.Text, { size: "small", text: "Which Screen?", label: true }),
                React.createElement(src_1.Text, { size: "large", text: screen ? screen.name : '' })),
            React.createElement("div", { style: {
                    height: '100%',
                    width: 64,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                } }, device === 'Mobile' ? this.renderMobileScreenPopover() : this.renderScreenPopover())));
    }
    renderMobileScreenPopover() {
        const { activePopover, device, isPopoverModalFormOpen } = this.props;
        const { isSearchFocused, screenSearch } = this.state;
        if (activePopover === 'experience-screen-selector-popover') {
            return ReactDOM.createPortal(React.createElement(MobilePopover_1.default, { animation: isPopoverModalFormOpen, navbarProps: {
                    buttonLeft: 'Cancel',
                    buttonLeftCallback: this.closePopover,
                } },
                React.createElement("div", { style: {
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                    } },
                    React.createElement(src_1.PopoverSearch, { device: device, isSearchFocused: isSearchFocused, removeFocus: () => this.setState({
                            isSearchFocused: false,
                        }), setFocus: () => this.setState({ isSearchFocused: true }), submitText: (screenSearch) => this.setState({ screenSearch }), text: screenSearch }),
                    React.createElement("div", { style: {
                            flex: '1 1 auto',
                            overflowY: 'scroll',
                            paddingBottom: device === 'Mobile' ? 55 : 0,
                        } }, this.renderExperienceScreens()))), document.getElementById('mainModalLeft'));
        }
    }
    renderMobilePopover() {
        const { activePopover, device, isPopoverModalFormOpen } = this.props;
        const { isSearchFocused, experienceSearch } = this.state;
        if (activePopover === 'experience-selector-popover') {
            return ReactDOM.createPortal(React.createElement(MobilePopover_1.default, { animation: isPopoverModalFormOpen, navbarProps: {
                    buttonLeft: 'Cancel',
                    buttonLeftCallback: this.closePopover,
                } },
                React.createElement("div", { style: {
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                    } },
                    React.createElement(src_1.PopoverSearch, { device: device, isSearchFocused: isSearchFocused, removeFocus: () => this.setState({
                            isSearchFocused: false,
                        }), setFocus: () => this.setState({ isSearchFocused: true }), submitText: (experienceSearch) => this.setState({ experienceSearch }), text: experienceSearch }),
                    React.createElement("div", { style: {
                            flex: '1 1 auto',
                            overflowY: 'scroll',
                            paddingBottom: device === 'Mobile' ? 55 : 0,
                        } }, this.renderExperiences()))), document.getElementById('mainModalLeft'));
        }
    }
    renderScreenPopover() {
        const { activePopover, device, editableCampaign, updateActivePopover } = this.props;
        const { deliverable } = editableCampaign;
        const { tapBehavior } = deliverable;
        const screenID = tapBehavior.type === 'PRESENT_EXPERIENCE' ? tapBehavior.screenID : '';
        return (React.createElement(src_1.PopoverContainer, { id: "experience-selector-popover", onClick: () => activePopover === 'experience-screen-selector-popover'
                ? updateActivePopover('')
                : updateActivePopover('experience-screen-selector-popover'), popoverProps: {
                placement: 'left',
                device,
                navBarProperties: {
                    buttonLeft: 'Cancel',
                    buttonLeftCallback: this.closePopover,
                },
            }, targetParent: device === 'Desktop' ? 'mainModalView' : 'mainModalLeft', showPopover: activePopover === 'experience-screen-selector-popover' },
            React.createElement(src_1.Button, { text: !screenID ? 'Select' : 'Change', type: "regular", mouseDownColors: {
                    active: src_1.turquoise,
                    inactive: src_1.aquamarine,
                } }),
            this.renderScreenSearch()));
    }
    renderPopover() {
        const { activePopover, device, editableCampaign, updateActivePopover } = this.props;
        const { deliverable } = editableCampaign;
        const { tapBehavior } = deliverable;
        const experienceId = tapBehavior.type === 'PRESENT_EXPERIENCE' ? tapBehavior.experienceID : '';
        return (React.createElement(src_1.PopoverContainer, { id: "experience-selector-popover", onClick: () => activePopover === 'experience-selector-popover'
                ? updateActivePopover('')
                : updateActivePopover('experience-selector-popover'), popoverProps: {
                placement: 'left',
                device,
                navBarProperties: {
                    buttonLeft: 'Cancel',
                    buttonLeftCallback: this.closePopover,
                },
            }, targetParent: device === 'Desktop' ? 'mainModalView' : 'mainModalLeft', showPopover: activePopover === 'experience-selector-popover' },
            React.createElement(src_1.Button, { text: !experienceId ? 'Select' : 'Change', type: "regular", mouseDownColors: {
                    active: src_1.turquoise,
                    inactive: src_1.aquamarine,
                } }),
            this.renderSearch()));
    }
    renderScreenSearch() {
        const { device } = this.props;
        const { screenSearch, isSearchFocused } = this.state;
        return (React.createElement("div", { style: {
                width: device === 'Mobile' ? '100%' : 384,
                height: device === 'Mobile' ? '100%' : 296,
                display: 'flex',
                flexDirection: 'column',
            } },
            React.createElement(src_1.PopoverSearch, { device: device, isSearchFocused: isSearchFocused, removeFocus: () => this.setState({ isSearchFocused: false }), setFocus: () => this.setState({ isSearchFocused: true }), submitText: (screenSearch) => this.setState({ screenSearch }), text: screenSearch }),
            React.createElement("div", { style: {
                    flex: '1 1 auto',
                    overflowY: 'scroll',
                } }, this.renderExperienceScreens())));
    }
    renderSearch() {
        const { device } = this.props;
        const { experienceSearch, isSearchFocused } = this.state;
        return (React.createElement("div", { style: {
                width: device === 'Mobile' ? '100%' : 384,
                height: device === 'Mobile' ? '100%' : 296,
                display: 'flex',
                flexDirection: 'column',
            } },
            React.createElement(src_1.PopoverSearch, { device: device, isSearchFocused: isSearchFocused, removeFocus: () => this.setState({ isSearchFocused: false }), setFocus: () => this.setState({ isSearchFocused: true }), submitText: (experienceSearch) => this.setState({ experienceSearch }), text: experienceSearch }),
            React.createElement("div", { style: {
                    flex: '1 1 auto',
                    overflowY: 'scroll',
                } }, this.renderExperiences())));
    }
    render() {
        return (React.createElement("div", null,
            this.renderExperienceChooser(),
            this.renderScreenChooser(),
            this.renderExperiencePreview()));
    }
}
const mapStateToProps = (state) => ({
    activePopover: reducers_1.getActivePopover(state),
    editableCampaign: reducers_1.getEditableCampaign(state),
    experiences: reducers_1.getExperiences(state),
    isPopoverModalFormOpen: reducers_1.getIsPopoverModalFormOpen(state),
});
const mapDispatchToProps = (dispatch) => {
    return {
        closePopoverModalForm: () => dispatch(actions_1.closePopoverModalForm()),
        updateActivePhonePreview: (preview) => dispatch(actions_1.updateActivePhonePreview(preview)),
        updateActivePopover: (activePopover) => dispatch(actions_1.updateActivePopover(activePopover)),
        updateExperienceTapBehavior: (experienceID, screenID) => dispatch(actions_1.updateNotificationDeliverable({
            tapBehavior: {
                type: 'PRESENT_EXPERIENCE',
                experienceID,
                screenID,
            },
        })),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(ExperienceSelector);
